import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { checkTokenValidity } from 'helper/auth';
import { AppThunk } from 'redux/store';

export interface authState {
  token: string | null,
  isAuthenticated: boolean
}

const initialState: authState = {
  token: null,
  isAuthenticated: false
}


export const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    login: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        token: action.payload,
        isAuthenticated: true
      }
    },
    logout: (state) => {
      return {
        ...state,
        token: null,
        isAuthenticated: false
      }
    }
  },
})

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;